import { useState, useRef, useEffect } from "react";

function useVisible(initialIsVisible: boolean) {
  const [isVisible, setIsVisible] = useState(initialIsVisible);
  const ref: any = useRef(null);

  const handleClickOutside = (event: any) => {
    if (ref.current && !ref.current?.contains(event.target)) {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return { ref, isVisible, setIsVisible };
}

export default useVisible;

export function useVisibleTwo(initialIsVisible: boolean) {
  const [isVisible, setIsVisible] = useState(initialIsVisible);
  const ref: any = useRef(null);
  const ref2: any = useRef(null);

  const handleClickOutside = (event: any) => {
    // console.log("ref: ", ref.current);
    // console.log("event: ", event.target);
    // console.log("ref2: ", ref2?.current);

    if (ref.current && !ref.current?.contains(event.target)) {
      // if (ref2?.contains(event.target)) {
      // console.log("Inside Calender object");
      // console.log("Ref 2: ", ref2?.current);

      let d1 = document.getElementsByClassName("ant-picker-dropdown")[0];
      // console.log("D1 : ", d1);
      if (d1 && d1.contains(event.target)) {
        // console.log("onset : ", d1.contains(event.target));
      } else {
        setIsVisible(false);
      }
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return { ref, ref2, isVisible, setIsVisible };
}
